import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import { sendEmailVerification } from "firebase/auth";
import { useAuthValue } from "../../../../Infrastructure/States/authContext";
import { useDispatch, useSelector } from "react-redux";
import { incrementSteps } from "../../../../Infrastructure/States/educatorStepsSlice";
import { VerifyEmailFormBox, VerifyEmailMainBox } from "../../styles";
import ERROR_CONSTANTS from "../../../../Infrastructure/Constants/errorConstants";
import { ShowErrorToast } from "../../../Common/Toast/toast";
import useAuthentication from "../../../../Infrastructure/States/onAuthStateChange";
import { auth, database } from "../../../../Infrastructure/config";
import { ref, update } from "firebase/database";
import { USER_LOGS_CLIENT } from "../../../../Infrastructure/Constants/logsConstant";
import { safeClientLogEvent } from "../../../../Infrastructure/Utilities/safeClientLogEvent";
import { verifyEmailStepSX } from "./Styles/emailVerifyStepStyles";

export const VerifyEmailStep = () => {
  const user = auth.currentUser;
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const {userId} = useAuthentication()
  const [time, setTime] = useState(60);
  const userEmailAddress = user?.email;
  const emailVerifiedRef = useRef(null);
  const startTimeRef = useRef(Date.now());
  const [isOnline, setIsOnline] = useState(navigator.onLine)
  const { currentUser, timeActive, setTimeActive } = useAuthValue();
  const selectedRoute = useSelector(
    (state) => state.auth.selectedRouteBeforeVerified
    );
  const userData = useSelector((state) => state.userData.data);
  const email_verified = userData?.email_verified;
      const handleVerifiedEmailAction = () => {
    dispatch(incrementSteps());

  };
  const handleFirebaseErrors = (error) => {
    if (!error) {
      return;
    }
    let errorMessage = ERROR_CONSTANTS.GENERIC_ERROR_TOAST;
    switch (error.code) {
      case "auth/wrong-password":
        errorMessage =
          "Invalid password. Please check your password and try again.";
        break;
      case "auth/user-not-found":
        errorMessage = "User not found! Please Sign Up.";
        break;
      case "auth/too-many-requests":
        errorMessage =
          error?.error?.message || "Too many requests. Please try again later.";
        break;
      default:
        ShowErrorToast(error);
    }
    ShowErrorToast(errorMessage);
  };
  const resendEmailVerification = () => {
    sendEmailVerification(auth.currentUser)
      .then(() => {
        setTimeActive(true);
      })
      .catch(async(err) => {
        handleFirebaseErrors(err)
        await safeClientLogEvent({
        ...USER_LOGS_CLIENT.EMAIL_VERIFICATION_RESEND_FAILED,
        uid: userId || null,
        source: "verifyEmail.jsx",
        emailInfo: { email: userEmailAddress },
        metadata: null,
        error: err?.message || null
      });
      });
  };
  
  useEffect(() => {
      const handleOnline = () => setIsOnline(true);
      const handleOffline = () => setIsOnline(false);

      window.addEventListener("online", handleOnline);
      window.addEventListener("offline", handleOffline);

      return () => {
        window.removeEventListener("online", handleOnline);
        window.removeEventListener("offline", handleOffline);
      };
    }, []);

  useEffect(() => {
    const interval = setInterval(() => {
    const currentTime = Date.now();
    const elapsedTime = currentTime - startTimeRef.current;
    if (elapsedTime > 3 * 24 * 60 * 60 * 1000) {
      clearInterval(interval);
      return;
    }
      currentUser
        ?.reload()
        .then(() => {
        const emailVerified = currentUser?.emailVerified;
        if (emailVerifiedRef.current !== emailVerified) {
          emailVerifiedRef.current = emailVerified
          const userRef = ref(database, `users/${currentUser.uid}`);
          update(userRef, { email_verified: emailVerified })
        }
        if (emailVerified) {
            selectedRoute && navigate(selectedRoute);
            clearInterval(interval);
          }
        })
        .catch((err) => {
            if (
              err.code === "auth/network-request-failed" ||
              err.message?.toLowerCase().includes("network") ||
              err.message?.toLowerCase().includes("internet")
            ) {
              return;
            }
          ShowErrorToast(ERROR_CONSTANTS.GENERIC_ERROR_TOAST)
        });
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [currentUser, selectedRoute, navigate, isOnline]);
  useEffect(() => {
    let interval = null;
    if (timeActive && time !== 0) {
      interval = setInterval(() => {
        setTime((time) => time - 1);
      }, 1000);
    } else if (time === 0) {
      setTimeActive(false);
      setTime(60);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [timeActive, time, setTimeActive]);
  return (
    <Box>
      <VerifyEmailMainBox>
        <Typography
          variant="h1"
          color="primary"
          sx={verifyEmailStepSX.heading}
        >
          Verify Account
        </Typography>
        <VerifyEmailFormBox>
          <Box sx={verifyEmailStepSX.contentWrapper}>
            <Box sx={verifyEmailStepSX.messageBox}>
              {email_verified ? (
                <Typography
                  variant="body2"
                  color="secondary"
                  sx={verifyEmailStepSX.messageText}
                >
                  Email verified successfully now you can proceed to next step.
                </Typography>
              ) : (
                <>
                  <Typography
                    variant="body2"
                    color="secondary"
                    sx={verifyEmailStepSX.messageText}
                  >
                    Verification Link sent to email <br />
                  </Typography>
                  <Typography
                    variant="body2"
                    color="secondary"
                    sx={verifyEmailStepSX.emailText}
                  >
                    {userEmailAddress}
                  </Typography>
                </>
              )}
            </Box>
            {email_verified ? (
              <>
                <Button
                  variant="contained"
                  onClick={handleVerifiedEmailAction}
                >
                  Go to Next Step
                </Button>
              </>
            ) : (
              <Box sx={verifyEmailStepSX.resendWrapper}>
                <Button
                  variant="contained"
                  onClick={resendEmailVerification}
                  disabled={timeActive}
                >
                  Resend Email {timeActive && time}
                </Button>
              </Box>
            )}
            <Typography
              variant="body2"
              color={"secondary"}
              sx={verifyEmailStepSX.footerText}
            >
              {email_verified
                ? "Enhance your skills with Vulcan Learning"
                : "Not Seeing the email? Ensure your email is correct and check the spam/junk folder."}
            </Typography>
          </Box>
        </VerifyEmailFormBox>
      </VerifyEmailMainBox>
    </Box>
  );
};
